import { useEffect, useState } from "react";

interface Weather {
  temp: number;
  wind: number;
  code: number;
}

function weatherIcon(code: number): string {
  if (code === 0) return "☀";
  if (code <= 3) return "⛅";
  if (code <= 48) return "🌫";
  if (code <= 67) return "🌧";
  if (code <= 77) return "❄";
  if (code <= 82) return "🌦";
  return "⛈";
}

function weatherLabel(code: number, wind: number): string {
  if (code === 0 && wind < 7) return "Ясно · терраса открыта";
  if (code <= 3 && wind < 10) return "Облачно · терраса открыта";
  if (code <= 3) return "Ветрено · уточните погоду";
  if (code <= 48) return "Туман · уточните погоду";
  return "Осадки · уточните погоду";
}

export function useWeather() {
  const [weather, setWeather] = useState<Weather | null>(null);

  useEffect(() => {
    fetch(
      "https://api.open-meteo.com/v1/forecast?latitude=59.9311&longitude=30.3609&current=temperature_2m,wind_speed_10m,weather_code&wind_speed_unit=ms"
    )
      .then((r) => r.json())
      .then((d) => {
        setWeather({
          temp: Math.round(d.current.temperature_2m),
          wind: Math.round(d.current.wind_speed_10m),
          code: d.current.weather_code,
        });
      })
      .catch(() => {});
  }, []);

  return weather;
}

export function WeatherStrip({ weather }: { weather: Weather | null }) {
  if (!weather) return null;
  return (
    <div className="flex-1 px-6 py-5 border-r border-white/10 min-w-[50%] md:min-w-0">
      <div className="text-[8px] tracking-[0.25em] text-white/35 uppercase mb-1">Погода сейчас</div>
      <div className="text-[13px] text-white/80 flex items-center gap-2">
        <span>{weatherIcon(weather.code)}</span>
        <span>{weather.temp}°C · {weather.wind} м/с</span>
      </div>
    </div>
  );
}

export function WeatherCard({ weather }: { weather: Weather | null }) {
  if (!weather) return null;
  const icon = weatherIcon(weather.code);
  const label = weatherLabel(weather.code, weather.wind);
  const isNice = weather.code <= 3 && weather.wind < 10;

  return (
    <div className="border border-primary/20 bg-card p-6 flex items-center gap-5">
      <div className="text-4xl leading-none">{icon}</div>
      <div>
        <div className="text-2xl font-serif font-light text-foreground mb-1">{weather.temp}°C</div>
        <div className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground">{label}</div>
        <div className="text-[10px] tracking-[0.15em] uppercase mt-1" style={{ color: isNice ? "hsl(var(--accent))" : "hsl(var(--muted-foreground))" }}>
          Ветер {weather.wind} м/с
        </div>
      </div>
    </div>
  );
}
